import React, { useEffect, useState } from "react";

const INVITE_ERR_FLAG = "pp:inviteError";

/**
 * A minimal, professional toast that appears bottom-right.
 * - Does NOT affect layout or navbar height (position: fixed).
 * - Auto-dismisses after 8s, or can be closed manually.
 */
export default function InviteStatusBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const flag = sessionStorage.getItem(INVITE_ERR_FLAG);
    if (flag === "denied") {
      setVisible(true);
      sessionStorage.removeItem(INVITE_ERR_FLAG);
    }
  }, []);

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => setVisible(false), 8000);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: "fixed",
        zIndex: 1080,           // above navbar
        right: "16px",
        bottom: "16px",
        maxWidth: "420px",
      }}
    >
      <div
        className="shadow-sm border rounded-3"
        style={{
          background: "var(--bs-body-bg)",
          borderColor: "var(--bs-border-color)",
        }}
      >
        <div
          className="d-flex align-items-start gap-3 p-3"
          style={{ lineHeight: 1.3 }}
        >
          <div
            className="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
            aria-hidden="true"
            style={{
              width: 28,
              height: 28,
              background: "var(--bs-warning-bg-subtle)",
              color: "var(--bs-warning-text)",
              border: "1px solid var(--bs-warning-border-subtle)",
              fontWeight: 700,
              fontSize: 14,
            }}
          >
            !
          </div>

          <div className="me-auto">
            <div className="fw-semibold mb-1">Not invited yet</div>
            <div className="text-body-secondary">
              Your Google account isn’t on the beta list. Request an invite and
              we’ll email you when you’re approved.
            </div>
            <div className="mt-2">
              <a href="#demo" className="btn btn-warning btn-sm">
                Request invite
              </a>
            </div>
          </div>

          <button
            type="button"
            className="btn btn-outline-secondary btn-sm border-0"
            aria-label="Close"
            onClick={() => setVisible(false)}
            style={{ lineHeight: 1 }}
            title="Dismiss"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
